import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FaqAction } from "stores/FaqTableStore/FaqAction";


const mapStateToProps = (state) => {
  return {
    CategoriesList:state.Faq.CategoriesList,
    FaqTableList: state.Faq.FaqTableList,
    isloadingFaqTable: state.Faq.FaqTable,
    ParentCategoriesList: state.Faq.ParentCategoriesList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCategoriesList: FaqAction.getFaqCategories,
      postFaqAction: FaqAction.postFaqAction,
      getFaqTableAction: FaqAction.getFaqAction,
      getFaqParentCategories: FaqAction.getFaqParentCategories,
      updateFaq: FaqAction.updateFaq,
     
    },
    dispatch
  );

const FaqCategoryStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default FaqCategoryStore;
